<div class="modal-container">
  <div class="modal-header">
    <h2 class="modal-title">{{ modalTitle }}</h2>
    <button mat-icon-button class="close-button" type="button" (click)="onCancel()" aria-label="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-content">
    <p class="modal-description">{{ modalDescription }}</p>
    <p class="modal-info" role="note">{{ fullLoadInfoMessage }}</p>

    <div class="form-stack">
      <div class="date-fields">
        <datapicker-input [datapicker]="startDateInput" (valueEmitter)="onDateRangeChange()"></datapicker-input>
        <datapicker-input [datapicker]="endDateInput" (valueEmitter)="onDateRangeChange()"></datapicker-input>
      </div>

      @if (validationMessage; as message) {
      <p class="modal-validation-error" role="alert">{{ message }}</p>
      }

      <div class="file-field">
        <label class="form-label">
          Arquivo de execução <span class="optional-label">(opcional)</span>
        </label>
        <app-upload-card
          [subtitle]="''"
          [buttonText]="'ANEXAR ARQUIVO'"
          [acceptedFileTypes]="'*/*'"
          [isFileNameEditable]="false"
          [secondType]="true"
          [existingFile]="executionExistingFile"
          (fileUpload)="onExecutionFileSelected($event)"
          (fileDelete)="onExecutionFileDelete()">
        </app-upload-card>
      </div>

      <mat-slide-toggle
        color="primary"
        class="skip-etl-toggle"
        [checked]="triggerEtlDag"
        (change)="triggerEtlDag = $event.checked">
        Disparar DAG
      </mat-slide-toggle>
    </div>
  </div>

  <div class="modal-footer">
    <button-induxtry [buttonProperties]="{
        label: 'Cancelar',
        customStyle: 'secondary',
        showLabel: true,
        key: 'cancel'
      }" (action)="onCancel()">
    </button-induxtry>

    <button-induxtry [buttonProperties]="{
        label: 'Iniciar execução',
        customStyle: 'primary',
        showLabel: true,
        customStyleFillIcon: true,
        key: 'confirm',
        disabled: !canConfirmExecution
      }" (action)="onConfirm()">
    </button-induxtry>
  </div>
</div>
